import {CommonNs, type DropdownNs} from "@shared/types";
import {LanguageOptions} from "@shared/constants/language-options.constants";

export const visibilityOptions = [
    {
        iconType: 'fal',
        icon: 'Globe',
        name: 'Anyone',
        value: CommonNs.PermissionsEnums.EVERYONE,
        content: 'Visible to anyone who can view your content. Accessible by installed apps.'
    },
    {
        iconType: 'fal',
        icon: 'Lock',
        name: 'Only you',
        value: CommonNs.PermissionsEnums.ONLY_YOU,
        content: 'Only visible to you'
    }
] as DropdownNs.DropdownOptionsItem[]

export const currencyOptions = [
    // --- TOP 10 MOST TRADED CURRENCIES --- 1. US Dollar (USD) - UNIQUE $ ICON
    {
        iconType: 'fal',
        icon: 'DollarSign',
        name: 'US Dollar',
        value: 'USD'
    },
    // 2. Euro (EUR)
    {
        iconType: 'fal',
        icon: 'Euro',
        name: 'Euro',
        value: 'EUR'
    },
    // 3. Japanese Yen (JPY)
    {
        iconType: 'fal',
        icon: 'JapaneseYen',
        name: 'Japanese Yen',
        value: 'JPY'
    },
    // 4. British Pound (GBP)
    {
        iconType: 'fal',
        icon: 'PoundSterling',
        name: 'Pound Sterling',
        value: 'GBP'
    },
    // 5. Chinese Yuan (CNY) - No FontAwesome icon available
    {
        name: 'Chinese Yuan',
        value: 'CNY'
    },
    // 6. Australian Dollar (AUD) - No FontAwesome icon available
    {
        name: 'Australian Dollar',
        value: 'AUD'
    },
    // 7. Canadian Dollar (CAD) - No FontAwesome icon available
    {
        name: 'Canadian Dollar',
        value: 'CAD'
    },
    // 8. Swiss Franc (CHF)
    {
        iconType: 'fal',
        icon: 'Banknote',
        name: 'Swiss Franc',
        value: 'CHF'
    },
    // 9. Hong Kong Dollar (HKD) - No FontAwesome icon available
    {
        name: 'Hong Kong Dollar',
        value: 'HKD'
    },
    // 10. Singapore Dollar (SGD) - No FontAwesome icon available
    {
        name: 'Singapore Dollar',
        value: 'SGD'
    },

    {
        name: 'Swedish Krona',
        value: 'SEK'
    },
    // 12. South Korean Won (KRW)
    {
        iconType: 'fal',
        icon: 'Banknote',
        name: 'South Korean Won',
        value: 'KRW'
    },
    // 13. Norwegian Krone (NOK) - No FontAwesome icon available
    {
        name: 'Norwegian Krone',
        value: 'NOK'
    },
    // 14. New Zealand Dollar (NZD) - No FontAwesome icon available
    {
        name: 'New Zealand Dollar',
        value: 'NZD'
    },
    // 15. Indian Rupee (INR)
    {
        iconType: 'fal',
        icon: 'IndianRupee',
        name: 'Indian Rupee',
        value: 'INR'
    },
    // 16. Mexican Peso (MXN) - No FontAwesome icon available
    {
        name: 'Mexican Peso',
        value: 'MXN'
    },
    // 17. New Taiwan Dollar (TWD) - No FontAwesome icon available
    {
        name: 'New Taiwan Dollar',
        value: 'TWD'
    },
    // 18. South African Rand (ZAR) - No FontAwesome icon available
    {
        name: 'South African Rand',
        value: 'ZAR'
    },
    // 19. Brazilian Real (BRL) - No FontAwesome icon available
    {
        name: 'Brazilian Real',
        value: 'BRL'
    },
    // 20. Danish Krone (DKK) - No FontAwesome icon available
    {
        name: 'Danish Krone',
        value: 'DKK'
    },

    {
        name: 'Polish Złoty',
        value: 'PLN'
    },
    // 22. Turkish Lira (TRY)
    {
        iconType: 'fal',
        icon: 'TurkishLira',
        name: 'Turkish Lira',
        value: 'TRY'
    },

    // 24. Indonesian Rupiah (IDR) - No FontAwesome icon available
    {
        name: 'Indonesian Rupiah',
        value: 'IDR'
    },
    // 25. Czech Koruna (CZK) - No FontAwesome icon available
    {
        name: 'Czech Koruna',
        value: 'CZK'
    },
    // 26. Kuwaiti Dinar (KWD) - No FontAwesome icon available
    {
        name: 'Kuwaiti Dinar',
        value: 'KWD'
    },
    // 27. Thai Baht (THB) - No FontAwesome icon available
    {
        name: 'Thai Baht',
        value: 'THB'
    },
] as DropdownNs.DropdownOptionsItem[]

export const countryOptions = [
    {
        iconType: 'fal',
        icon: 'Globe',
        name: 'Turkey',
        value: 'Turkey'
    },
    {
        iconType: 'fal',
        icon: 'Globe',
        name: 'Germany',
        value: 'Germany'
    }
] as DropdownNs.DropdownOptionsItem[]

export const selectableProperties: CommonNs.InputFormGroup[] = [
    {
        label: 'City',
        icon: 'MapPin',
        iconType: 'fal',
        input: {
            name: 'city',
            type: 'text',
            placeholder: 'City',
            value: ''
        },
        dropdown: {
            name: 'cityPermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Country',
        icon: 'Globe',
        iconType: 'fal',
        input: {
            name: 'country',
            type: 'select',
            placeholder: 'Country',
            value: '',
            selectOptions: countryOptions
        },
        dropdown: {
            name: 'countryPermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Phone',
        icon: 'Phone',
        iconType: 'fal',
        input: {
            name: 'phone',
            type: 'text',
            placeholder: 'Phone',
            value: ''
        },
        dropdown: {
            name: 'phonePermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Mobile',
        icon: 'Smartphone',
        iconType: 'fal',
        input: {
            name: 'mobile',
            type: 'text',
            placeholder: 'Mobile',
            value: ''
        },
        dropdown: {
            name: 'mobilePermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Email',
        icon: 'AtSign',
        iconType: 'fal',
        input: {
            name: 'email',
            type: 'text',
            placeholder: 'Email',
            value: ''
        },
        dropdown: {
            name: 'emailPermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Website',
        icon: 'Link',
        iconType: 'fal',
        input: {
            name: 'website',
            type: 'text',
            placeholder: 'Website',
            value: ''
        },
        dropdown: {
            name: 'websitePermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Linkedin',
        icon: 'linkedin',
        iconType: 'fab',
        input: {
            name: 'linkedin',
            type: 'text',
            placeholder: 'Linkedin',
            value: ''
        },
        dropdown: {
            name: 'linkedinPermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Facebook',
        icon: 'facebook',
        iconType: 'fab',
        input: {
            name: 'facebook',
            type: 'text',
            placeholder: 'Facebook',
            value: ''
        },
        dropdown: {
            name: 'facebookPermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Instagram',
        icon: 'instagram',
        iconType: 'fab',
        input: {
            name: 'instagram',
            type: 'text',
            placeholder: 'Instagram',
            value: ''
        },
        dropdown: {
            name: 'instagramPermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Twitter',
        icon: 'twitter',
        iconType: 'fab',
        input: {
            name: 'twitter',
            type: 'text',
            placeholder: 'Twitter',
            value: ''
        },
        dropdown: {
            name: 'twitterPermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Youtube',
        icon: 'youtube',
        iconType: 'fab',
        input: {
            name: 'youtube',
            type: 'text',
            placeholder: 'Youtube',
            value: ''
        },
        dropdown: {
            name: 'youtubePermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Whatsapp',
        icon: 'whatsapp',
        iconType: 'fab',
        input: {
            name: 'whatsapp',
            type: 'text',
            placeholder: 'Whatsapp',
            value: ''
        },
        dropdown: {
            name: 'whatsappPermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Telegram',
        icon: 'telegram',
        iconType: 'fab',
        input: {
            name: 'telegram',
            type: 'text',
            placeholder: 'Telegram',
            value: ''
        },
        dropdown: {
            name: 'telegramPermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Language',
        icon: 'Globe',
        iconType: 'fal',
        input: {
            name: 'language',
            type: 'multiselect',
            placeholder: 'Language',
            value: '',
            selectOptions: LanguageOptions
        },
        dropdown: {
            name: 'languagePermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Hourly Rate',
        icon: 'Clock',
        iconType: 'fal',
        input: {
            name: 'hourly_rate',
            type: 'range',
            placeholder: 'Hourly Rate',
            value: {},
            selectOptions: currencyOptions
        },
        dropdown: {
            name: 'hourlyRatePermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Daily Rate',
        icon: 'Calendar',
        iconType: 'fal',
        input: {
            name: 'daily_rate',
            type: 'range',
            placeholder: 'Daily Rate',
            value: {},
            selectOptions: currencyOptions
        },
        dropdown: {
            name: 'dailyRatePermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    },
    {
        label: 'Custom Property',
        icon: 'Settings',
        iconType: 'fal',
        input: {
            name: 'custom',
            type: 'text',
            placeholder: 'Custom Property',
            value: ''
        },
        dropdown: {
            name: 'customPropPermission',
            options: visibilityOptions,
            value: CommonNs.PermissionsEnums.EVERYONE
        }
    }
]

export const titleOptions = [
    {
        value: 'PRODUCT_OWNER',
        name: 'Product Owner'
    },
    {
        value: 'PROJECT_MANAGER',
        name: 'Project Manager'
    },
    {
        value: 'BUSINESS_ANALYST',
        name: 'Business Analyst'
    },
    {
        value: 'DESIGNER',
        name: 'Designer'
    },
    {
        value: 'DEVELOPER',
        name: 'Developer'
    },
    {
        value: 'ENGINEER',
        name: 'Engineer'
    },
    {
        value: 'RESEARCHER',
        name: 'Researcher'
    },
    {
        value: 'MARKETER',
        name: 'Marketer'
    },
    {
        value: 'WRITER',
        name: 'Writer'
    },
    {
        value: 'C_LEVEL',
        name: 'C-Level'
    },
    {
        value: 'FOUNDER',
        name: 'Founder'
    },
    {
        value: 'OTHER',
        name: 'Other'
    }
] as DropdownNs.DropdownOptionsItem[]

export const organizationOptions = [
    {
        name: 'Startup',
        value: 'STARTUP'
    },
    {
        name: 'Agency',
        value: 'AGENCY'
    },
    {
        name: 'Software House',
        value: 'SOFTWARE_HOUSE'
    },
    {
        name: 'Consulting',
        value: 'CONSULTING'
    },
    {
        name: 'Freelance',
        value: 'FREELANCE'
    },
    {
        name: 'SMB',
        value: 'SMB'
    },
    {
        name: 'Cooperate',
        value: 'COOPERATE'
    },
    {
        name: 'EDU',
        value: 'EDU'
    },
    {
        name: 'NGO',
        value: 'NGO'
    },
    {
        name: 'Other',
        value: 'OTHER'
    }
] as DropdownNs.DropdownOptionsItem[]

export const companySizeOptions = [
    {
        name: '0-1',
        value: '0-1'
    },
    {
        name: '2-10',
        value: '2-10'
    },
    {
        name: '11-50',
        value: '11-50'
    },
    {
        name: '51-200',
        value: '51-200'
    },
    {
        name: '200+',
        value: '200+'
    }
] as DropdownNs.DropdownOptionsItem[]

export const businessFocusOptions = [
    {
        name: 'Make offer for clients',
        title: 'Make offer for clients',
        value: 'make-offer-for-clients'
    },
    {
        name: 'Create digital product',
        title: 'Create digital product',
        value: 'create-digital-product'
    },
    {
        name: 'Create a non-digital product',
        title: 'Create a non-digital product',
        value: 'create-non-digital-product'
    }
] as DropdownNs.DropdownOptionsItem[]
